"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var SupportedModelsProperties_1 = require("./SupportedModelsProperties");
var Field_1 = require("../../constants/Field");
var Objects_1 = require("../../api/Objects");
var SupportedModelsType = /** @class */ (function () {
    function SupportedModelsType() {
    }
    SupportedModelsType.fromJson = function (json) {
        var supportedModelsType = new SupportedModelsType();
        supportedModelsType.model = json.model;
        supportedModelsType.name = json.name;
        supportedModelsType.typeId = json.typeId;
        supportedModelsType.version = json.version;
        supportedModelsType.properties = SupportedModelsProperties_1.SupportedModelsProperties.fromJson(json.properties);
        return supportedModelsType;
    };
    SupportedModelsType.prototype.toInstance = function (withValue) {
        var json = Object.create(null);
        json[Field_1.FIELD.MODEL] = this.model;
        json[Field_1.FIELD.TYPE] = this.typeId + "@" + this.version.split('.')[0];
        json[Field_1.FIELD.NAME] = this.name;
        json[Field_1.FIELD.PROPERTIES] = withValue ? this.properties.toInstanceWithValueField() : this.properties.toInstance();
        return json;
    };
    SupportedModelsType.prototype.saveSupportedModels = function (withValue) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var json, objects, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        json = this.toInstance(withValue);
                        objects = new Objects_1.Objects();
                        return [4 /*yield*/, objects.saveObject(JSON.stringify(json))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    return SupportedModelsType;
}());
exports.SupportedModelsType = SupportedModelsType;
//# sourceMappingURL=SupportedModels.js.map